import {
    Accordion, AccordionActions, AccordionDetails, AccordionSummary, Avatar, Box, Button, Divider, Grid, List, ListItem, ListItemAvatar,
    ListItemSecondaryAction, ListItemText, Typography
} from '@material-ui/core'
import { Add, CheckCircleOutlineOutlined, Delete, ExpandLess, ExpandMore, HighlightOffOutlined, UnfoldMore } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Swal from "sweetalert2"
import plusIcon from "../../../assets/images/plus-circle.svg"
import { useStyles } from '../../../components/common/MainStyles'
import { deleteExistingProduct, selectExistingProduct } from '../../../store/shopping/shopping.actions'
import { getProductList, getProducts } from '../../../store/shopping/shopping.selector'
import { getDeliveryAddresses } from '../../../store/user/deliveryaddress/deliveryaddress.selector'
import { getImage, getUserProfile } from '../../../store/user/user.selector'
import ProductCard from '../product_card'

export const ProductControl = ({ onDelete, isSelected }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [editProduct, setEditProduct] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [open, setOpen] = React.useState(false);
    const [newProduct, setNewProduct] = useState(false);
    const [addAddress, setAddAddress] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const {
        products,
        productList,
        userProfile,
        deliveryAddress,
        deliveryLoading,
    } = useSelector((state) => {
        return {
            products: getProductList(state),
            productList: getProducts(state),
            userProfile: getUserProfile(state),
            deliveryAddress: getDeliveryAddresses(state),
            deliveryLoading: state.DeliveryAddressReducer.isLoading,
        };
    });

    useEffect(() => {
        setNewProduct(false);
        setEditProduct(false);
    }, [products, productList]);

    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected])

    useEffect(() => {
        if ((newProduct || open) && !addAddress) {
            if (!deliveryLoading && deliveryAddress.length === 0) {
                Swal.fire({
                    allowOutsideClick: false,
                    title: "Add your address",
                    text: "You haven’t added any shipping address yet please click below to add.",
                    icon: "warning",
                    iconHtml: `<img src="${require("../../../assets/images/map.png")}" />`,
                    confirmButtonText: "Add new address",
                    showCancelButton: true,
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                        icon: "custom-swal-icon",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        setAddAddress(true);
                    }
                    if (result.isDismissed) {
                        setNewProduct(false);
                        setOpen(false);
                        setEditProduct(false);
                    }
                });
            }
        }
    }, [newProduct, open, deliveryAddress, deliveryLoading]);

    const ProductSquare = ({ pos, showing }) => {
        return (
            <Grid item xs={4} sm={4} lg={showing ? 6 : 4} xl={showing ? 6 : 4}>
                <Box
                    onClick={() => {
                        if (products && products.length > pos) {
                            setEditProduct(true);
                            setSelectedProduct(products[pos]);
                        } else {
                            setNewProduct(true);
                        }
                    }}
                    textAlign="center"
                    margin={"0 auto"}
                    className={classes.productBox}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    {products && products.length > pos ? (
                        <div className="img-wrap">
                            <HighlightOffOutlined
                                className="close"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(deleteExistingProduct(pos));
                                }}
                            />
                            <img
                                className="img-responsive"
                                src={products[pos].images}
                            />
                        </div>
                    ) : (
                        <img src={plusIcon} />
                    )}
                </Box>
            </Grid>
        );
    };

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.53072 3.76218C6.97926 3.86065 6.32605 4.13638 5.87306 4.45807C4.96709 5.10144 4.33685 6.09603 4.14647 7.17598C4.07097 7.6027 4.07097 16.623 4.14647 17.0497C4.24822 17.6373 4.50754 18.2675 4.84236 18.7402C5.05572 19.0422 5.53168 19.5215 5.83039 19.7381C6.3162 20.0893 6.96942 20.3618 7.55698 20.4668C7.99027 20.5423 17.004 20.5423 17.4373 20.4668C18.3039 20.3158 19.0654 19.9154 19.6957 19.2785C20.3193 18.645 20.7067 17.9032 20.8544 17.0465C20.9299 16.623 20.9266 7.59942 20.8544 7.17598C20.7001 6.29955 20.2931 5.53144 19.6464 4.9012C19.1475 4.41539 18.6354 4.10356 18.0249 3.90661C17.3881 3.70309 17.6014 3.70966 12.4709 3.71294C8.56799 3.71622 7.74737 3.72279 7.53072 3.76218ZM17.434 5.22945C18.4253 5.53801 19.0753 6.18794 19.3838 7.17926L19.4757 7.46812V12.1129V16.7576L19.3838 17.0465C19.0753 18.0378 18.4253 18.6877 17.434 18.9963L17.1452 19.0882H12.5004H7.85569L7.56683 18.9963C6.57552 18.6877 5.92558 18.0378 5.61703 17.0465L5.52512 16.7576V12.1129V7.46812L5.61703 7.17926C5.96169 6.07634 6.82499 5.3148 7.91478 5.15396C8.00997 5.14083 10.1239 5.13098 12.6153 5.13426L17.1452 5.13754L17.434 5.22945Z" fill="#CECECE" />
                                <path d="M12.1702 7.9769C12.0061 8.06225 11.8846 8.20012 11.8256 8.36752C11.7829 8.48898 11.7763 8.73844 11.7763 9.94969V11.3907H10.3353C8.76299 11.3907 8.71047 11.3973 8.5168 11.5811C8.36581 11.7255 8.29688 11.8896 8.29688 12.1129C8.29688 12.3525 8.37237 12.5232 8.54306 12.6643C8.74658 12.8284 8.80238 12.835 10.3452 12.835H11.7763V14.276C11.7763 15.8483 11.7829 15.9009 11.9667 16.0945C12.1111 16.2455 12.2753 16.3145 12.4985 16.3145C12.7381 16.3145 12.9088 16.239 13.0499 16.0683C13.2141 15.8648 13.2206 15.8089 13.2206 14.2662V12.835H14.6518C16.1946 12.835 16.2504 12.8284 16.4539 12.6643C16.7789 12.3951 16.792 11.8765 16.4801 11.5811C16.2865 11.3973 16.234 11.3907 14.6616 11.3907H13.2206V9.95953C13.2206 8.98135 13.2075 8.48569 13.1845 8.40035C13.1353 8.23622 12.981 8.05569 12.8234 7.9769C12.656 7.89156 12.3311 7.89156 12.1702 7.9769Z" fill="#CECECE" />
                            </svg>
                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Product
                        </div>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='w-full'>
                        <Grid container spacing={2}>
                            {
                                newProduct ? (
                                    <ProductCard
                                        product={{}}
                                        isAdd={true}
                                        onClose={() =>
                                            setNewProduct(false)
                                        }
                                    />
                                ) : editProduct ? (
                                    <ProductCard
                                        product={selectedProduct}
                                        isAdd={false}
                                        onClose={() =>
                                            setEditProduct(false)
                                        }
                                    />
                                ) : (
                                    <></>
                                )
                            }
                            {
                                userProfile.role === "Basic" ? (
                                    <>
                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
                                            (pr, index) => {
                                                return (
                                                    <ProductSquare
                                                        pos={index}
                                                    />
                                                );
                                            }
                                        )}
                                    </>
                                ) :
                                    <>
                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                                            10, 11, 12, 13, 14, 15, 16, 17].map(
                                                (pr, index) => {
                                                    return (
                                                        <ProductSquare
                                                            pos={index}
                                                        />
                                                    );
                                                }
                                            )}
                                    </>
                            }
                        </Grid>
                        {productList.length > 0 && (
                            <Button
                                startIcon={<Add />}
                                color="primary"
                                className="my-1 float-right"
                                variant="outlined"
                                onClick={() => setOpen(true)}
                            >
                                Add Product
                            </Button>
                        )}

                        <div
                            className="sidenav"
                            style={{ width: open ? "35%" : 0 }}
                        >
                            <div className="p-4">
                                <Typography
                                    variant="p"
                                    component="p"
                                    className={classes.dashboardTitle}
                                >
                                    Saved Products
                                </Typography>
                            </div>
                            <Divider />
                            <List
                                disablePadding
                                className={classes.sideList}
                            >
                                {productList.map((x) => {
                                    let isExists =
                                        products.filter(
                                            (y) => x._id === y._id
                                        ).length > 0;
                                    return (
                                        <ListItem
                                            disableGutters
                                            onClick={() => {
                                                if (!isExists) {
                                                    let data = {
                                                        status: x.status,
                                                        shippingFee:
                                                            x.shippingFee,
                                                        _id: x._id,
                                                        name: x.name,
                                                        descriptions:
                                                            x.descriptions,
                                                        images: x.images
                                                            ? x.images
                                                            : getImage(
                                                                x.attachments
                                                            ),
                                                        attachments:
                                                            x
                                                                .attachments
                                                                ._id,
                                                        price: x.price,
                                                        user: x.user,
                                                        code: x.code,
                                                        currency:
                                                            x.currency,
                                                        warehouse:
                                                            x.warehouse
                                                                ._id,
                                                        dateCreated:
                                                            x.dateCreated,
                                                        dateUpdated:
                                                            x.dateUpdated,
                                                        quantity:
                                                            x.warehouse
                                                                .quantity,
                                                        purcharse:
                                                            x.warehouse
                                                                .purcharse,
                                                        remaining:
                                                            x.warehouse
                                                                .remaining,
                                                    };
                                                    dispatch(
                                                        selectExistingProduct(
                                                            data
                                                        )
                                                    );
                                                }
                                            }}
                                        >
                                            <ListItemAvatar>
                                                <Avatar
                                                    variant="square"
                                                    sizes="100"
                                                    src={
                                                        x.images
                                                            ? x.images
                                                            : getImage(
                                                                x.attachments,
                                                                "product"
                                                            )
                                                    }
                                                    className="img-responsive"
                                                    alt="icon"
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={x.name}
                                                secondary={x.code}
                                            />
                                            <ListItemSecondaryAction>
                                                {isExists ? (
                                                    <CheckCircleOutlineOutlined color="primary" />
                                                ) : (
                                                    <CheckCircleOutlineOutlined
                                                        color="disabled"
                                                        onClick={() => {
                                                            if (
                                                                !isExists
                                                            ) {
                                                                let data =
                                                                {
                                                                    status: x.status,
                                                                    shippingFee:
                                                                        x.shippingFee,
                                                                    _id: x._id,
                                                                    name: x.name,
                                                                    descriptions:
                                                                        x.descriptions,
                                                                    images: x.images
                                                                        ? x.images
                                                                        : getImage(
                                                                            x.attachments
                                                                        ),
                                                                    attachments:
                                                                        x
                                                                            .attachments
                                                                            ._id,
                                                                    price: x.price,
                                                                    user: x.user,
                                                                    code: x.code,
                                                                    currency:
                                                                        x.currency,
                                                                    warehouse:
                                                                        x
                                                                            .warehouse
                                                                            ._id,
                                                                    dateCreated:
                                                                        x.dateCreated,
                                                                    dateUpdated:
                                                                        x.dateUpdated,
                                                                    quantity:
                                                                        x
                                                                            .warehouse
                                                                            .quantity,
                                                                    purcharse:
                                                                        x
                                                                            .warehouse
                                                                            .purcharse,
                                                                    remaining:
                                                                        x
                                                                            .warehouse
                                                                            .remaining,
                                                                };
                                                                dispatch(
                                                                    selectExistingProduct(
                                                                        data
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    );
                                })}
                            </List>
                            <Button
                                color="secondary"
                                variant="contained"
                                className="m-2"
                                fullWidth
                                onClick={() => {
                                    setOpen(false);
                                    setExpanded(false);
                                }}
                            >
                                Done
                            </Button>
                        </div>
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setNewProduct(false);
                            setOpen(false);
                            setEditProduct(false);
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
